module.exports = __webpack_public_path__ + "static/media/card-blog2.f9e9828f.jpg";